export default __webpack_public_path__ + "static/media/box-1.5137a3fc.png";